// extracted by mini-css-extract-plugin
export default {"HeaderComponent":"HeaderComponent_kQEPL"};